var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3 10.3H0V16h5.7v-2.3H2.3v-3.4ZM0 5.7h2.3V2.3h3.4V0H0v5.7Zm13.7 8h-3.4V16H16v-5.7h-2.3v3.4ZM10.3 0v2.3h3.4v3.4H16V0h-5.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreen);
export default ForwardRef;